<template>
    <Button
        @click="isOpen = true"
        iconName="edit"
        color="light"
        size="small"
    >
        Edit
    </Button>

    <Drawer
        @close="isOpen = false"
        :show="isOpen"
    >
        <template #title> Edit </template>
        <template #content>
            <ApiForm
                :url="
                    urlFactory.makeServicePriceUpdateUrl(
                        servicePrice.serviceId,
                        servicePrice.id,
                    )
                "
                method="POST"
                ref="apiFormRef"
                :disableCatch="true"
            >
                <ServicePriceForm
                    :servicePrice="servicePrice"
                    :errors="
                        apiFormRef?.response?.getErrors() ??
                        new ApiFormErrors({})
                    "
                />
            </ApiForm>
        </template>
        <template #actions>
            <Button
                @click="isOpen = false"
                color="light"
            >
                Cancel
            </Button>
            <Button
                @click="submit"
                iconName="save"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Update
            </Button>
        </template>
    </Drawer>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import Drawer from '@/Shared/Component/Drawer.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import ServicePrice from '@/App/Service/Entity/ServicePrice'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import ServicePriceForm from '@/App/Service/Component/ServicePrice/ServicePriceForm.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'

    const emits = defineEmits<{
        onSuccess: [ServiceAggregate]
    }>()

    const props = defineProps({
        servicePrice: {
            type: Object as PropType<ServicePrice>,
            required: true,
        },
    })

    const isOpen = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                emits(
                    'onSuccess',
                    response.getHydratedServiceAggregate(
                        ResponseJsonKeyEnum.App_ServicePrices_Update_ServiceAggregateData,
                    ),
                )
            })
            ?.finally(() => {
                isOpen.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
